import * as Popover from '@radix-ui/react-popover';
import React from 'react';

export default function PopoverInfo({
  trigger,
  children,
  side = 'top',
  maxWidth = 'sm' // ← DEFAULT SM
}) {
  const sizeClasses = {
    sm: 'max-w-sm',                                  // pequeño
    md: 'max-w-md',                                  // mediano
    lg: 'w-full max-w-full max-h-[90vh] mx-auto my-4', // pantalla casi completa
  };

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        {trigger}
      </Popover.Trigger>

      <Popover.Content
        side={side}
        align="center"
        sideOffset={6}
        className={`${sizeClasses[maxWidth]} z-50 overflow-auto bg-white  rounded-md shadow-lg p-3 text-sm text-gray-700`}
      >
        {children}
      </Popover.Content>
    </Popover.Root>
  );
}
